import EmployeeTable from "./EmployeeTable";
export type { Employee, EditEmployeeFormData } from "src/types/employee";
export default EmployeeTable;
